import { type QConfigTableData } from '@exam-management/common/types';
import { Dialog, Form, type DialogProps } from '@shared/components';
import { useState } from 'react';

import {
  AddSingleQuestionConditionsProvider,
  useAddSingleQuestionConditions,
} from '../../providers';
import type { ModalContentMapType } from '../../types';
import { SelectTopicContent, type SelectTopicContentProps } from '../select-topic-content';
import { UpdateSingleQuestionContent } from '../update-single-question-content';

export interface UpdateSingleQuestionConditionsModalProps extends DialogProps {
  onClose: () => void;
  rows: QConfigTableData[];
  data: QConfigTableData;
}

export default function UpdateSingleQuestionConditionsModal(
  props: Readonly<UpdateSingleQuestionConditionsModalProps>,
) {
  const { onClose, open: isModalOpen, rows, data } = props;
  const [modalContent, setModalContent] = useState<keyof ModalContentMapType>(
    'ADD_SINGLE_QUESTION_CONTENT',
  );

  const changeToEditSingleQuestionContent = () => {
    setModalContent('ADD_SINGLE_QUESTION_CONTENT');
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={onClose}
      slotProps={{
        paper: {
          component: Form,
        },
      }}
    >
      <AddSingleQuestionConditionsProvider chapterId={data.parentId} initialValues={{ rows, data }}>
        {modalContent === 'ADD_SINGLE_QUESTION_CONTENT' ? (
          <UpdateSingleQuestionContent
            onClose={onClose}
            setModalContent={setModalContent}
            questionTypeData={data}
          />
        ) : null}
        {modalContent === 'SELECT_TOPIC_CONTENT' ? (
          <SelectTopicContentWithContext
            onClose={onClose}
            onBack={changeToEditSingleQuestionContent}
          />
        ) : null}
      </AddSingleQuestionConditionsProvider>
    </Dialog>
  );
}

function SelectTopicContentWithContext(
  props: Readonly<Pick<SelectTopicContentProps, 'onClose' | 'onBack'>>,
) {
  const { onClose, onBack } = props;
  const { chapterData, levelItemsWithLevel, checkExistOnStructures } =
    useAddSingleQuestionConditions();

  return (
    <SelectTopicContent
      mode='edit'
      chapterData={chapterData}
      levelItemsWithLevel={levelItemsWithLevel}
      checkExistOnStructures={checkExistOnStructures}
      onClose={onClose}
      onBack={onBack}
    />
  );
}
